import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import size from 'lodash/size';
import {
  API,
  withRouter,
  viCancelCircleOutline,
} from 'vibeguide';
import Grid from '@mui/material/Grid';
import OrderStatusCard from '../OrderStatusCard';

function CancelledOrderTables() {
  const [summaries, setSummaries] = useState({});

  /**
   * Get the Order Status Summary
   */
  const getSummaries = async () => {
    const past = await API.Order.Reporting.Summaries.Cancelled.past();

    setSummaries({
      past,
    });
  };

  useEffect(() => {
    getSummaries();
  }, []);

  return (
    <Grid className="CancelledOrderTables" spacing={2} container>
      <Grid size={12}>
        <OrderStatusCard
          title="Cancelled in the last 30 Days"
          linkUrl="../../cancelled/past"
          icon={viCancelCircleOutline}
          tableData={{
            hideColumn: false,
            columns: ['name', 'status', 'deliveredImpressions', 'startDate', 'endDate', 'cancellationDate'],
            data: get(summaries, 'past', []),
          }}
          loading={size(summaries) <= 0}
        />
      </Grid>
    </Grid>
  );
}

export default withRouter(CancelledOrderTables);
